import { createContext, useContext } from "react";

export const LangContext = createContext({ lang: "fr", setLang: () => {}, t: {} });
export const useLang = () => useContext(LangContext);

const fr = {
  phone1: "+216 58 521 125",
  phone2: "+216 54 777 000",
  email1: "ridha.klai@slm.com.tn",
  email2: "r.elkateb@slm.com.tn",
  address: "Z.I Sbikha 1, 3110 Kairouan · Tunisie",
  nav: {
    tagline: "Fabriqué en Tunisie · Export",
    links: [
      { label: "Produits", href: "#produits" },
      { label: "Entreprise", href: "#entreprise" },
      { label: "Qualité", href: "#qualite" },
      { label: "FAQ", href: "#faq" },
      { label: "Contact", href: "#devis" },
    ],
    cta: "Devis",
  },
  hero: {
    overline: "Fabricant tunisien d'emballages",
    lines: ["Du préforme", "au gobelet."],
    sub: "K&K produit la chaîne complète de l'emballage boisson — préformes PET, bouchons, film rétractable et gobelets — sur des lignes automatisées haute cadence. Personnalisation, approvisionnement fiable, export.",
    ctaPrimary: "Demander un devis",
    ctaSecondary: "Voir les produits",
    stats: [
      { value: "1 000 t/mois", label: "Capacité préformes PET" },
      { value: "100 000 /h", label: "Cadence bouchons" },
      { value: "4 gammes", label: "Préforme · Bouchon · Film · Gobelet" },
      { value: "Export ready", label: "Fabriqué en Tunisie" },
    ],
  },
  marquee: ["Fabriqué en Tunisie", "Export", "Qualité PET alimentaire", "Préformes", "Bouchons", "Film rétractable", "Gobelets", "100 000 bouchons / heure"],
  features: [
    { title: "Qualité alimentaire", sub: "Matériaux adaptés aux boissons" },
    { title: "Précision & contrôle", sub: "Inspection sur chaque série" },
    { title: "Personnalisation", sub: "Coloris, marquage, formats" },
    { title: "Prêt pour l'export", sub: "Conditionnement adapté" },
  ],
  products: {
    overline: "Nos produits",
    title: "Toute la chaîne d'emballage boisson",
    desc: "Quatre gammes complémentaires, de la mise en bouteille à la distribution.",
    badge: "Le plus demandé",
    cta: "Voir la fiche technique",
    pdfLabel: "Télécharger la fiche (PDF)",
    pdfLabel28: "Fiche 28,3 g — cols 30/25 & 29/25 (PDF)",
    items: [
      { name: "Préformes PET", desc: "Préformes injectées pour bouteilles d'eau, teinte cristal ou bleu, de 0,5 L à 2 L.", specs: ["15–38 g", "Col 30/25", "Cristal · Bleu"], href: "#gamme-preformes" },
      { name: "Bouchons 30/25", desc: "Bouchons monobloc avec inviolabilité, sur l'une des plus grandes machines d'Afrique.", specs: ["7 coloris", "Bericap", "PEHD"], href: "#gamme-bouchons" },
      { name: "Film rétractable", desc: "Film rétractable pour le fardelage des packs d'eau et de boissons.", specs: ["45–80 µm", "PEBD", "Fardelage packs"], href: "#gamme-film" },
      { name: "Gobelets", desc: "Gobelets alimentaires pour eau, café et boissons, personnalisables à votre marque.", specs: ["12 · 18 · 25 cl", "Carton", "Impression"], href: "#gamme-gobelets" },
    ],
  },
  formats: {
    overline: "Préformes par format",
    title: "Un grammage pour chaque bouteille",
    desc: "Nos préformes couvrent les bouteilles d'eau de 0,5 L à 2 L, en col 30/25 (29/25 disponible), teinte cristal ou bleu.",
    items: [
      { tag: "Col 30/25", title: "Série eau · 15–38 g", desc: "Préformes cristal pour bouteilles d'eau de 0,5 L à 2 L, en col 30/25.", specs: ["15 · 28,3 · 35 · 38 g", "Cristal"] },
      { tag: "Col 29/25", title: "Col 29/25 · 15 g", desc: "Col alternatif disponible, notamment sur le grammage 15 g (bouteille 0,5 L).", specs: ["15 g", "0,5 L"] },
      { tag: "Teinte bleu", title: "Teinte bleu", desc: "Préformes teintées bleu pour un rendu de bouteille différenciant, sur demande.", specs: ["Sur demande", "Cristal · Bleu"] },
    ],
  },
  anatomy: {
    overline: "Anatomie",
    title: "Une préforme pensée dans le détail",
    desc: "Chaque zone est contrôlée pour un soufflage régulier et un bouchage fiable.",
    planCaption: "Coupe cotée — préforme 35 g (section A-A)",
    callouts: [
      { n: "01", title: "Finition du col 30/25", desc: "Filetage court pour un bouchage rapide et fiable." },
      { n: "02", title: "Bague de support", desc: "Stabilité pendant le soufflage, le transport et la manutention." },
      { n: "03", title: "Corps lisse", desc: "Épaisseur de paroi uniforme, contrôlée à ±0,1 mm." },
      { n: "04", title: "Dôme", desc: "Répartition optimale de la matière au soufflage." },
    ],
    chips: [
      { k: "Col", v: "30/25" },
      { k: "Teinte", v: "Cristal · Bleu" },
      { k: "Procédé", v: "Injection" },
      { k: "Matière", v: "PET alim." },
      { k: "Volumes", v: "0,5–2 L" },
      { k: "Qualité", v: "Contrôlée" },
    ],
  },
  ranges: [
    {
      id: "gamme-preformes", index: "01", name: "Préformes PET",
      desc: "Préformes injectées pour bouteilles d'eau, en teinte cristal ou bleu, de 0,5 L à 2 L.",
      rows: [
        { k: "Grammages", v: "15 · 28,3 · 35 · 38 g" },
        { k: "Col", v: "30/25 (15 g et 28,3 g aussi en 29/25)" },
        { k: "Matière", v: "Résine PET qualité alimentaire" },
        { k: "Teintes", v: "Cristal · Bleu" },
        { k: "Procédé", v: "Moulage par injection" },
        { k: "Contrôle", v: "Poids, dimensions, teinte — chaque série" },
        { k: "Traçabilité", v: "N° de lot + date sur chaque emballage" },
      ],
      grammage: {
        title: "Spécifications par grammage",
        head: ["Grammage", "Hauteur", "Ø ext", "Ø int", "Épaisseur", "Pcs / carton"],
        rows: [
          ["15 g ±0,2", "90,0 mm", "18,91 mm", "13,66 mm", "2,63 mm", "14 976"],
          ["28,3 g ±0,3", "113,5 mm", "25,56 mm", "20,00 mm", "2,78 mm", "8 280"],
          ["35 g ±0,3", "127,5 mm", "25,69 mm", "19,34 mm", "3,18 mm", "7 200"],
          ["38 g ±0,5", "128,0 mm", "25,50 mm", "18,50 mm", "4,00 mm", "7 200"],
        ],
      },
      plans: [{ src: "/assets/plan-preforme.png", caption: "Plan technique — préforme 35 g, section A-A" }],
      plansTitle: "Plans officiels par grammage (PDF)",
      drawings: [
        { label: "15 g — col 30/25", href: "/assets/plans/plan-preforme-15g-30-25.pdf" },
        { label: "28,5 g — col 30/25", href: "/assets/plans/plan-preforme-28-5g-30-25.pdf" },
        { label: "35 g — col 30/25", href: "/assets/plans/plan-preforme-35g-30-25.pdf" },
        { label: "28 g — col 29/25", href: "/assets/plans/plan-preforme-28g-29-25.pdf" },
      ],
      tags: ["Eau plate", "Eau gazeuse", "Capacité 1 000 t/mois"],
    },
    {
      id: "gamme-bouchons", index: "02", name: "Bouchons 30/25",
      desc: "Systèmes de bouchage produits sur l'une des plus grandes machines à bouchons d'Afrique.",
      rows: [
        { k: "Col", v: "30/25 · Ø col 30,30 ±0,20 mm" },
        { k: "Type", v: "Bouchon à vis monobloc, bande d'inviolabilité" },
        { k: "Matière", v: "PEHD — qualité alimentaire" },
        { k: "Poids", v: "1,80 ±0,05 g" },
        { k: "Ø ext / int", v: "32,40 ±0,30 / 28,90 ±0,20 mm" },
        { k: "Hauteur", v: "16,90 ±0,20 mm · 90 stries" },
        { k: "Épaisseur", v: "0,70 ±0,10 mm" },
        { k: "Procédé", v: "Moulage par compression" },
        { k: "Cadence", v: "100 088 unités / heure" },
        { k: "Contrôle", v: "Double caméra · marquage K&K" },
        { k: "Emballage", v: "4 200 pcs/carton · 25 cartons/palette" },
      ],
      plans: [
        { src: "/assets/plan-bouchon-coupe.png", caption: "Coupe cotée — bouchon 30/25" },
        { src: "/assets/plan-bouchon-top.png", caption: "Vue de dessus — gravure K&K" },
        { src: "/assets/plan-bouchon-paire.png", caption: "Rainures latérales — 90 stries" },
      ],
      tags: [],
      colors: [
        { name: "Orange", hex: "#FF7A00" }, { name: "Bleu foncé", hex: "#173F8A" },
        { name: "Blanc", hex: "#F2F2F0" }, { name: "Bronze", hex: "#A6763C" },
        { name: "Bleu clair", hex: "#7FB5E8" }, { name: "Rouge", hex: "#D42B2B" },
        { name: "Vert clair", hex: "#8FCB6B" },
      ],
      customColor: "Sur mesure",
    },
    {
      id: "gamme-film", index: "03", name: "Film rétractable",
      desc: "Film rétractable pour le fardelage des packs d'eau et de boissons, manuel ou automatique.",
      rows: [
        { k: "Type", v: "Rétractable (film de fardelage)" },
        { k: "Matière", v: "Polyéthylène (PEBD)" },
        { k: "Épaisseur", v: "45 – 80 µm" },
        { k: "Laize", v: "Sur mesure" },
        { k: "Usage", v: "Fardelage de packs (eau & boissons)" },
      ],
      tags: ["Packs d'eau", "Protection transport", "Impression"],
    },
    {
      id: "gamme-gobelets", index: "04", name: "Gobelets carton",
      desc: "Gobelets en carton pour eau, café et boissons, personnalisables à votre marque.",
      rows: [
        { k: "Contenances", v: "12 · 18 · 25 cl" },
        { k: "Matière", v: "Carton qualité alimentaire" },
        { k: "Usages", v: "Café, eau, distributeur, boissons" },
        { k: "Personnalisation", v: "Impression multicolore, à votre marque" },
      ],
      tags: ["12 cl", "18 cl", "25 cl"],
    },
  ],
  applications: {
    overline: "Applications",
    title: "Des solutions pour chaque usage",
    desc: "Nos produits accompagnent l'embouteillage, la distribution et la logistique.",
    items: [
      { title: "Eau plate", desc: "Préformes et bouchons pour bouteilles d'eau de 0,5 L à 2 L." },
      { title: "Eau gazeuse & boissons", desc: "Bouchages inviolables pour boissons gazeuses et jus." },
      { title: "Café & distribution", desc: "Gobelets pour distributeurs, machines à café et vente à emporter." },
      { title: "Fardelage", desc: "Film rétractable pour fardeler et protéger vos packs d'eau et boissons." },
      { title: "Marques", desc: "Coloris et impressions sur mesure pour différencier vos produits." },
      { title: "Export", desc: "Conditionnement adapté à l'expédition internationale." },
    ],
  },
  about: {
    overline: "L'entreprise",
    title: "Le savoir-faire de l'emballage, à l'échelle industrielle",
    p1: "K&K conçoit et produit les composants plastiques essentiels de la filière eau minérale et boissons : de la préforme PET au gobelet, en passant par le bouchon et le film.",
    p2: "Nos lignes automatisées offrent une cadence élevée et une constance dimensionnelle, avec un contrôle qualité sur chaque série — et une capacité pensée pour les marchés d'export.",
    cta: "Demander un devis",
    highlights: [
      { value: "1 000 t/mois", label: "Capacité préformes PET" },
      { value: "Contrôle qualité", label: "Inspection sur chaque série" },
      { value: "Machine bouchons", label: "Parmi les plus grandes d'Afrique" },
    ],
    note: "Visuel d'illustration — remplaçable par une photo réelle de l'usine.",
  },
  stats: {
    overline: "En chiffres",
    title: "Une capacité industrielle",
    items: [
      { value: "1 000", label: "Tonnes de préformes / mois" },
      { value: "100 000", label: "Bouchons produits / heure" },
      { value: "4", label: "Gammes de produits" },
      { value: "7+", label: "Coloris de bouchons" },
    ],
  },
  process: {
    overline: "Qualité & process",
    title: "Maîtrisé de la matière à l'expédition",
    desc: "Chaque étape est contrôlée pour garantir la régularité de nos produits.",
    steps: [
      { n: "1", title: "Matière", desc: "Résine qualité alimentaire, adaptée aux boissons." },
      { n: "2", title: "Production", desc: "Injection et lignes automatisées haute cadence." },
      { n: "3", title: "Contrôle qualité", desc: "Poids, dimensions, étanchéité et teintes vérifiés." },
      { n: "4", title: "Conditionnement", desc: "Emballage export contrôlé avant expédition." },
    ],
    checks: ["Poids & grammage", "Dimensions du col", "Étanchéité & inviolabilité", "Teinte & transparence", "Aspect visuel"],
    markets: ["Tunisie", "Maghreb", "Afrique", "Europe", "Moyen-Orient"],
    cta: {
      overline: "Approvisionnement",
      title: "Construisons votre programme d'emballage",
      desc: "Indiquez-nous vos volumes, formats, coloris et cadences : notre équipe vous propose la solution adaptée à votre ligne, en Tunisie comme à l'export.",
      primary: "Demander un devis",
      secondary: "Contacter l'équipe",
    },
  },
  faq: {
    overline: "FAQ",
    title: "Questions fréquentes",
    desc: "L'essentiel pour préparer votre commande.",
    items: [
      { q: "Quelle différence entre les cols 30/25 et 29/25 ?", a: "Ce sont deux standards de col pour bouteilles d'eau. Nos préformes et bouchons sont principalement en 30/25 ; le 29/25 est disponible (notamment sur le grammage 15 g). Nous confirmons toujours la compatibilité col / bouchon avant production." },
      { q: "Proposez-vous des couleurs de bouchons personnalisées ?", a: "Oui. Sept coloris standard (orange, bleu foncé, blanc, bronze, bleu clair, rouge, vert clair), ainsi que des teintes sur mesure, l'impression et le marquage selon votre cahier des charges." },
      { q: "Quel type de film proposez-vous ?", a: "Nous produisons du film rétractable destiné au fardelage des packs d'eau et de boissons. L'épaisseur et la laize sont adaptées à vos formats de packs et à votre fardeleuse. Impression possible." },
      { q: "Peut-on obtenir des échantillons avant commande ?", a: "Des échantillons peuvent être fournis sur demande pour valider la compatibilité avec vos lignes (soufflage, bouchage, palettisation) avant une commande en volume." },
      { q: "Livrez-vous à l'export ?", a: "Oui. Nos produits sont fabriqués en Tunisie et conditionnés pour l'expédition internationale. Indiquez-nous votre destination pour organiser la logistique." },
    ],
  },
  quote: {
    overline: "Demander un devis",
    title: "Parlons de votre projet d'emballage",
    desc: "Remplissez le formulaire : nous préparons une proposition adaptée à vos formats et volumes.",
    labels: { phone: "Téléphone", email: "E-mail", origin: "Origine" },
    hints: ["Le produit et le format souhaités", "Coloris ou personnalisation", "La quantité et le marché"],
    note: "Réponse rapide de notre équipe commerciale.",
    form: {
      name: "Nom complet *",
      company: "Société",
      email: "E-mail *",
      phone: "Téléphone",
      product: "Produit",
      quantity: "Quantité estimée",
      customTitle: "Personnalisation",
      details: "Détails & spécifications",
      submit: "Envoyer la demande",
      sending: "Envoi en cours…",
      success: "Demande envoyée — notre équipe vous répond rapidement.",
      error: "Erreur lors de l'envoi. Réessayez ou contactez-nous par téléphone.",
      products: ["Préformes PET", "Bouchons 30/25", "Film rétractable", "Gobelets", "Plusieurs produits"],
      quantities: ["À définir", "Moins de 10 000", "10 000 – 100 000", "100 000 – 1 000 000", "Plus de 1 000 000"],
      customOptions: ["Coloris sur mesure", "Impression / marquage", "Bericap", "Échantillon d'abord"],
    },
    reassure: ["Sans engagement", "Réponse rapide", "Échantillon possible"],
  },
  footer: {
    tagline: "Fabricant tunisien de préformes PET, bouchons, film rétractable et gobelets pour la filière eau & boissons.",
    badges: ["Qualité alimentaire", "Contrôle qualité", "Made in Tunisia", "Export"],
    productsTitle: "Produits",
    companyTitle: "Société",
    companyLinks: [
      { label: "Entreprise", href: "#entreprise" },
      { label: "Qualité", href: "#qualite" },
      { label: "Applications", href: "#applications" },
      { label: "FAQ", href: "#faq" },
    ],
    contactTitle: "Contact",
    cataloguesTitle: "Catalogues 2026",
    catalogueMain: "Préformes · Bouchons · Film (PDF)",
    catalogueCups: "Gobelets carton (PDF)",
    catalogueMainEn: "Préformes · Bouchons · Film (PDF · EN)",
    catalogueCupsEn: "Gobelets carton (PDF · EN)",
    qualities: [
      { title: "Qualité alimentaire", sub: "Matériaux adaptés" },
      { title: "Export", sub: "Livraison internationale" },
      { title: "Contrôle qualité", sub: "Chaque série vérifiée" },
      { title: "Personnalisation", sub: "Coloris & marquage" },
    ],
    copyright: "© 2026 K&K Packaging — Tous droits réservés",
    baseline: "Préformes · Bouchons · Films · Gobelets",
    photoCredit: "Photo préforme : Frank Murmann — CC BY 3.0",
  },
};

const en = {
  phone1: "+216 58 521 125",
  phone2: "+216 54 777 000",
  email1: "ridha.klai@slm.com.tn",
  email2: "r.elkateb@slm.com.tn",
  address: "Z.I Sbikha 1, 3110 Kairouan · Tunisia",
  nav: {
    tagline: "Made in Tunisia · Export",
    links: [
      { label: "Products", href: "#produits" },
      { label: "Company", href: "#entreprise" },
      { label: "Quality", href: "#qualite" },
      { label: "FAQ", href: "#faq" },
      { label: "Contact", href: "#devis" },
    ],
    cta: "Quote",
  },
  hero: {
    overline: "Tunisian packaging manufacturer",
    lines: ["From preform", "to paper cup."],
    sub: "K&K produces the complete beverage packaging chain — PET preforms, caps, shrink film and cups — on high-speed automated lines. Customization, reliable supply, export.",
    ctaPrimary: "Request a quote",
    ctaSecondary: "View products",
    stats: [
      { value: "1,000 t/month", label: "PET preform capacity" },
      { value: "100,000 /h", label: "Cap production rate" },
      { value: "4 ranges", label: "Preform · Cap · Film · Cup" },
      { value: "Export ready", label: "Made in Tunisia" },
    ],
  },
  marquee: ["Made in Tunisia", "Export", "Food-grade PET quality", "Preforms", "Caps", "Shrink film", "Cups", "100,000 caps / hour"],
  features: [
    { title: "Food-grade quality", sub: "Materials suited for beverages" },
    { title: "Precision & control", sub: "Inspection on every batch" },
    { title: "Customization", sub: "Colours, marking, formats" },
    { title: "Export ready", sub: "Adapted packaging" },
  ],
  products: {
    overline: "Our products",
    title: "The complete beverage packaging chain",
    desc: "Four complementary ranges, from bottling to distribution.",
    badge: "Most requested",
    cta: "View spec sheet",
    pdfLabel: "Download spec sheet (PDF)",
    pdfLabel28: "28.3 g sheet — 30/25 & 29/25 necks (PDF)",
    items: [
      { name: "PET Preforms", desc: "Injection-moulded preforms for water bottles, crystal or blue tint, from 0.5 L to 2 L.", specs: ["15–38 g", "Neck 30/25", "Crystal · Blue"], href: "#gamme-preformes" },
      { name: "Caps 30/25", desc: "One-piece tamper-evident caps, produced on one of Africa's largest cap machines.", specs: ["7 colours", "Bericap", "HDPE"], href: "#gamme-bouchons" },
      { name: "Shrink film", desc: "Shrink film for bundling water and beverage packs.", specs: ["45–80 µm", "LDPE", "Pack bundling"], href: "#gamme-film" },
      { name: "Cups", desc: "Food-grade cups for water, coffee and beverages, custom-printed with your brand.", specs: ["12 · 18 · 25 cl", "Paperboard", "Printing"], href: "#gamme-gobelets" },
    ],
  },
  formats: {
    overline: "Preforms by format",
    title: "A grammage for every bottle",
    desc: "Our preforms cover water bottles from 0.5 L to 2 L, in 30/25 neck (29/25 available), crystal or blue tint.",
    items: [
      { tag: "Neck 30/25", title: "Water series · 15–38 g", desc: "Crystal preforms for water bottles from 0.5 L to 2 L, in 30/25 neck.", specs: ["15 · 28.3 · 35 · 38 g", "Crystal"] },
      { tag: "Neck 29/25", title: "Neck 29/25 · 15 g", desc: "Alternative neck available, notably on the 15 g grammage (0.5 L bottle).", specs: ["15 g", "0.5 L"] },
      { tag: "Blue tint", title: "Blue tint", desc: "Blue-tinted preforms for a distinctive bottle look, on request.", specs: ["On request", "Crystal · Blue"] },
    ],
  },
  anatomy: {
    overline: "Anatomy",
    title: "A preform engineered in detail",
    desc: "Every zone is inspected for consistent blowing and reliable capping.",
    planCaption: "Dimensioned section — 35 g preform (section A-A)",
    callouts: [
      { n: "01", title: "30/25 neck finish", desc: "Short thread for fast, reliable capping." },
      { n: "02", title: "Support ring", desc: "Stability during blowing, transport and handling." },
      { n: "03", title: "Smooth body wall", desc: "Uniform wall thickness, controlled to ±0.1 mm." },
      { n: "04", title: "Dome top", desc: "Optimal material distribution during blowing." },
    ],
    chips: [
      { k: "Neck", v: "30/25" },
      { k: "Tint", v: "Crystal · Blue" },
      { k: "Process", v: "Injection" },
      { k: "Material", v: "Food-grade PET" },
      { k: "Volumes", v: "0.5–2 L" },
      { k: "Quality", v: "Controlled" },
    ],
  },
  ranges: [
    {
      id: "gamme-preformes", index: "01", name: "PET Preforms",
      desc: "Injection-moulded preforms for water bottles, crystal or blue tint, from 0.5 L to 2 L.",
      rows: [
        { k: "Grammages", v: "15 · 28.3 · 35 · 38 g" },
        { k: "Neck", v: "30/25 (15 g and 28.3 g also in 29/25)" },
        { k: "Material", v: "Food-grade PET resin" },
        { k: "Tints", v: "Crystal · Blue" },
        { k: "Process", v: "Injection moulding" },
        { k: "Control", v: "Weight, dimensions, tint — every batch" },
        { k: "Traceability", v: "Batch no. + date on every package" },
      ],
      grammage: {
        title: "Specifications by grammage",
        head: ["Grammage", "Height", "OD", "ID", "Wall", "Pcs / carton"],
        rows: [
          ["15 g ±0.2", "90.0 mm", "18.91 mm", "13.66 mm", "2.63 mm", "14,976"],
          ["28.3 g ±0.3", "113.5 mm", "25.56 mm", "20.00 mm", "2.78 mm", "8,280"],
          ["35 g ±0.3", "127.5 mm", "25.69 mm", "19.34 mm", "3.18 mm", "7,200"],
          ["38 g ±0.5", "128.0 mm", "25.50 mm", "18.50 mm", "4.00 mm", "7,200"],
        ],
      },
      plans: [{ src: "/assets/plan-preforme.png", caption: "Technical drawing — 35 g preform, section A-A" }],
      plansTitle: "Official drawings by grammage (PDF)",
      drawings: [
        { label: "15 g — 30/25 neck", href: "/assets/plans/plan-preforme-15g-30-25.pdf" },
        { label: "28.5 g — 30/25 neck", href: "/assets/plans/plan-preforme-28-5g-30-25.pdf" },
        { label: "35 g — 30/25 neck", href: "/assets/plans/plan-preforme-35g-30-25.pdf" },
        { label: "28 g — 29/25 neck", href: "/assets/plans/plan-preforme-28g-29-25.pdf" },
      ],
      tags: ["Still water", "Sparkling water", "Capacity 1,000 t/month"],
    },
    {
      id: "gamme-bouchons", index: "02", name: "Caps 30/25",
      desc: "Closure systems produced on one of the largest cap machines in Africa.",
      rows: [
        { k: "Neck", v: "30/25 · neck Ø 30.30 ±0.20 mm" },
        { k: "Type", v: "One-piece screw cap, tamper-evident band" },
        { k: "Material", v: "HDPE — food grade" },
        { k: "Weight", v: "1.80 ±0.05 g" },
        { k: "OD / ID", v: "32.40 ±0.30 / 28.90 ±0.20 mm" },
        { k: "Height", v: "16.90 ±0.20 mm · 90 knurls" },
        { k: "Wall", v: "0.70 ±0.10 mm" },
        { k: "Process", v: "Compression moulding" },
        { k: "Rate", v: "100,088 units / hour" },
        { k: "Control", v: "Dual camera · K&K marking" },
        { k: "Packaging", v: "4,200 pcs/carton · 25 cartons/pallet" },
      ],
      plans: [
        { src: "/assets/plan-bouchon-coupe.png", caption: "Dimensioned section — 30/25 cap" },
        { src: "/assets/plan-bouchon-top.png", caption: "Top view — K&K engraving" },
        { src: "/assets/plan-bouchon-paire.png", caption: "Side knurls — 90 knurls" },
      ],
      tags: [],
      colors: [
        { name: "Orange", hex: "#FF7A00" }, { name: "Dark blue", hex: "#173F8A" },
        { name: "White", hex: "#F2F2F0" }, { name: "Bronze", hex: "#A6763C" },
        { name: "Light blue", hex: "#7FB5E8" }, { name: "Red", hex: "#D42B2B" },
        { name: "Light green", hex: "#8FCB6B" },
      ],
      customColor: "Custom",
    },
    {
      id: "gamme-film", index: "03", name: "Shrink film",
      desc: "Shrink film for bundling water and beverage packs, manual or automatic.",
      rows: [
        { k: "Type", v: "Shrink (bundling film)" },
        { k: "Material", v: "Polyethylene (LDPE)" },
        { k: "Thickness", v: "45 – 80 µm" },
        { k: "Width", v: "Made to measure" },
        { k: "Use", v: "Pack bundling (water & beverages)" },
      ],
      tags: ["Water packs", "Transport protection", "Printing"],
    },
    {
      id: "gamme-gobelets", index: "04", name: "Paper cups",
      desc: "Paperboard cups for water, coffee and beverages, custom-printed with your brand.",
      rows: [
        { k: "Capacities", v: "12 · 18 · 25 cl" },
        { k: "Material", v: "Food-grade paperboard" },
        { k: "Uses", v: "Coffee, water, vending, beverages" },
        { k: "Customization", v: "Multicolour printing, your brand" },
      ],
      tags: ["12 cl", "18 cl", "25 cl"],
    },
  ],
  applications: {
    overline: "Applications",
    title: "Solutions for every use",
    desc: "Our products support bottling, distribution and logistics.",
    items: [
      { title: "Still water", desc: "Preforms and caps for water bottles from 0.5 L to 2 L." },
      { title: "Sparkling & beverages", desc: "Tamper-evident closures for carbonated drinks and juices." },
      { title: "Coffee & vending", desc: "Cups for vending machines, coffee machines and takeaway." },
      { title: "Bundling", desc: "Shrink film to bundle and protect your water and beverage packs." },
      { title: "Brands", desc: "Custom colours and printing to differentiate your products." },
      { title: "Export", desc: "Packaging adapted to international shipping." },
    ],
  },
  about: {
    overline: "The company",
    title: "Packaging know-how, at industrial scale",
    p1: "K&K designs and produces the essential plastic components of the mineral water and beverage industry: from PET preforms to cups, including caps and film.",
    p2: "Our automated lines deliver high output and dimensional consistency, with quality control on every batch — and a capacity built for export markets.",
    cta: "Request a quote",
    highlights: [
      { value: "1,000 t/month", label: "PET preform capacity" },
      { value: "Quality control", label: "Inspection on every batch" },
      { value: "Cap machine", label: "Among the largest in Africa" },
    ],
    note: "Illustration visual — replaceable with a real factory photo.",
  },
  stats: {
    overline: "In numbers",
    title: "Industrial capacity",
    items: [
      { value: "1,000", label: "Tonnes of preforms / month" },
      { value: "100,000", label: "Caps produced / hour" },
      { value: "4", label: "Product ranges" },
      { value: "7+", label: "Cap colours" },
    ],
  },
  process: {
    overline: "Quality & process",
    title: "Controlled from resin to shipment",
    desc: "Every step is inspected to guarantee the consistency of our products.",
    steps: [
      { n: "1", title: "Material", desc: "Food-grade resin, suited for beverages." },
      { n: "2", title: "Production", desc: "Injection and high-speed automated lines." },
      { n: "3", title: "Quality control", desc: "Weight, dimensions, sealing and tints verified." },
      { n: "4", title: "Packaging", desc: "Export packaging checked before shipment." },
    ],
    checks: ["Weight & grammage", "Neck dimensions", "Sealing & tamper evidence", "Tint & transparency", "Visual appearance"],
    markets: ["Tunisia", "Maghreb", "Africa", "Europe", "Middle East"],
    cta: {
      overline: "Supply",
      title: "Let's build your packaging programme",
      desc: "Tell us your volumes, formats, colours and rates: our team will propose the solution suited to your line, in Tunisia and for export.",
      primary: "Request a quote",
      secondary: "Contact the team",
    },
  },
  faq: {
    overline: "FAQ",
    title: "Frequently asked questions",
    desc: "The essentials to prepare your order.",
    items: [
      { q: "What is the difference between 30/25 and 29/25 necks?", a: "These are two neck finish standards for water bottles. Our preforms and caps are mainly 30/25; 29/25 is available (notably on the 15 g grammage). We always confirm neck/cap compatibility before production." },
      { q: "Do you offer custom cap colours?", a: "Yes. Seven standard colours (orange, dark blue, white, bronze, light blue, red, light green), plus custom tints, printing and marking to your specification." },
      { q: "What type of film do you produce?", a: "We produce shrink film for bundling water and beverage packs. Thickness and width are adapted to your pack formats and your bundling machine. Printing available." },
      { q: "Can we get samples before ordering?", a: "Samples can be provided on request to validate compatibility with your lines (blowing, capping, palletizing) before a volume order." },
      { q: "Do you ship for export?", a: "Yes. Our products are made in Tunisia and packed for international shipping. Tell us your destination and we will organise the logistics." },
    ],
  },
  quote: {
    overline: "Request a quote",
    title: "Let's talk about your packaging project",
    desc: "Fill in the form: we will prepare a proposal adapted to your formats and volumes.",
    labels: { phone: "Phone", email: "E-mail", origin: "Origin" },
    hints: ["The product and format you need", "Colours or customization", "The quantity and market"],
    note: "Fast response from our sales team.",
    form: {
      name: "Full name *",
      company: "Company",
      email: "E-mail *",
      phone: "Phone",
      product: "Product",
      quantity: "Estimated quantity",
      customTitle: "Customization",
      details: "Details & specifications",
      submit: "Send request",
      sending: "Sending…",
      success: "Request sent — our team will get back to you shortly.",
      error: "Sending failed. Please retry or contact us by phone.",
      products: ["PET Preforms", "Caps 30/25", "Shrink film", "Cups", "Multiple products"],
      quantities: ["To be defined", "Less than 10,000", "10,000 – 100,000", "100,000 – 1,000,000", "More than 1,000,000"],
      customOptions: ["Custom colours", "Printing / marking", "Bericap", "Sample first"],
    },
    reassure: ["No commitment", "Fast response", "Sample available"],
  },
  footer: {
    tagline: "Tunisian manufacturer of PET preforms, caps, shrink film and cups for the water & beverage industry.",
    badges: ["Food-grade quality", "Quality control", "Made in Tunisia", "Export"],
    productsTitle: "Products",
    companyTitle: "Company",
    companyLinks: [
      { label: "Company", href: "#entreprise" },
      { label: "Quality", href: "#qualite" },
      { label: "Applications", href: "#applications" },
      { label: "FAQ", href: "#faq" },
    ],
    contactTitle: "Contact",
    cataloguesTitle: "2026 catalogues",
    catalogueMain: "Preforms · Caps · Film (PDF)",
    catalogueCups: "Paper cups (PDF)",
    catalogueMainEn: "Preforms · Caps · Film (PDF · EN)",
    catalogueCupsEn: "Paper cups (PDF · EN)",
    qualities: [
      { title: "Food-grade quality", sub: "Adapted materials" },
      { title: "Export", sub: "International delivery" },
      { title: "Quality control", sub: "Every batch verified" },
      { title: "Customization", sub: "Colours & marking" },
    ],
    copyright: "© 2026 K&K Packaging — All rights reserved",
    baseline: "Preforms · Caps · Films · Cups",
    photoCredit: "Preform photo: Frank Murmann — CC BY 3.0",
  },
};

export const content = { fr, en };
